import { Component, OnInit } from '@angular/core';

import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';
import { uploadService } from './../../../../shared/uploadService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ElectronicConsultationService } from '../../services/electronic-consultation.service';
import { ElectronicSharingService } from '../../../electronic-sharing/services/electronic-sharing.service';
import { switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ElectronicConsultation } from '../../Models/electronic-consultation';
import { ElectronicSharing } from '../../../electronic-sharing/Models/electronic-sharing';
import { QueryModel } from '../../../../shared/Models/queryModel';

@Component({
  selector: 'add-electronic-consultation',
  templateUrl: './add-electronic-consultation.component.html',
  styleUrls: ['./add-electronic-consultation.component.scss']
})
export class AddElectronicConsultationComponent implements OnInit {
  isLoading: boolean = false;
  model = {} as ElectronicConsultation;
  isEdit = false;
  validPhoto: boolean = true;
  previosusAttachments: FileVm[] = [];
  fileName: string[] = [];
  formData = new FormData();
  attachements: FormData;
  newPhotoUploaded = false;
  uploadThumbnail = false;
  electronicSharingList: ElectronicSharing[] = [];
  selectedElectronicSharingId: number;
  
  constructor( private diagRef: NbDialogRef<AddElectronicConsultationComponent>,
      private service: ElectronicConsultationService,
      private electronicSharingService: ElectronicSharingService,
      private uploadService: uploadService,
      private toast: NbToastrService,
      private route : Router) { }

 ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });

    // Load electronic sharing list
    this.loadElectronicSharingList();

    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
      this.selectedElectronicSharingId = this.model.electronicSharingId;
    } else {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.model.isIconEnabled = false;
      this.attachements = new FormData();
      this.uploadThumbnail = true;
      this.validPhoto = false;
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  loadElectronicSharingList() {
    const queryModel: QueryModel = {
      currentPage: 1,
      pageSize: 100,
      sort: 'id',
      sortDirection: 'asc',
      searchTerm: ''
    };
    
    this.electronicSharingService.get(queryModel).subscribe(
      (res) => {
        this.electronicSharingList = res.result || [];
      },
      (error) => {
        console.error('Error loading electronic sharing list:', error);
        this.toast.show('حدث خطأ أثناء تحميل قائمة المشاركة الإلكترونية', '', { status: 'danger', duration: 3000 });
      }
    );
  }

  removePhoot() {
    this.formData = new FormData();
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }
  updateElectronicConsultation() {
    this.isLoading = true;

    const imgUpload$ = this.newPhotoUploaded
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(this.model.thumbnail);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, files]) => {
          this.model.thumbnail = img;
          this.model.attachements = files;
          this.model.electronicSharingId = this.selectedElectronicSharingId;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل الاستشارة الإلكترونية بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while updating:', error);
          this.toast.show('حدث خطأ أثناء تعديل الاستشارة الإلكترونية', '', { status: 'danger', duration: 3000 });
        }
      );
  }
  save() {
    this.isLoading = true;

    const imgUpload$ = this.uploadService.uploadImage(this.formData);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, files]) => {
          this.model.thumbnail = img;
          this.model.attachements = files;
          this.model.electronicSharingId = this.selectedElectronicSharingId;
          return this.service.post(this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم إضافة استشارة إلكترونية جديدة بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while saving:', error);
          this.toast.show('حدث خطأ أثناء إضافة الاستشارة الإلكترونية', '', { status: 'danger', duration: 3000 });
        }
      );
  }
    getFormData(event) {
    this.formData = new FormData();
    this.formData = event;
    if (event) this.validPhoto = true;
    this.newPhotoUploaded = true;
  }

  uploadFile(event) {
    this.uploadService.updateFiles({ files: event, previousAttachments: this.model.attachements });
  }


  close() {
    this.diagRef.close();
  }
}


